import { useState, useEffect } from 'react'

const useScreenSize = () => {
  const [innerWidth, setInnerWidth] = useState(getDeviceSize())
  function getDeviceSize() {
    const width = window.innerWidth
    let deviceSize = ''

    switch (true) {
      case width < 768:
        deviceSize = 'sm' // Mobile 
        break
      case width >= 768 && width <= 992:
        deviceSize = 'tab' // tablet
        break
      case width >= 992 && width <= 1024:
        deviceSize = 'md' // Laptop
        break
      default:
        deviceSize = 'xl' // Desktop
    }

    return deviceSize
  }

  const handleResize = () => {
    setInnerWidth(getDeviceSize())
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return innerWidth
}

export default useScreenSize
